import PropTypes from 'prop-types'

import { Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

import { TextStyles } from 'utils/text'

const useStyles = makeStyles({
  'card-row-value': {
    fontWeight: 500,
  },
})

const CardRowValue = ({ children, className, ...props }) => {
  const classes = useStyles()

  return (
    <Typography
      {...TextStyles.paragraphDark({
        className: [classes['card-row-value'], className].join(' '),
        component: 'span',
      })}
      {...props}>
      {children}
    </Typography>
  )
}

CardRowValue.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.array,
    PropTypes.number,
  ]),
  className: PropTypes.string,
}

CardRowValue.defaultProps = {
  className: '',
}

export default CardRowValue
